import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { BMApiService } from '../../../services/bm.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../services/utility.service';
import { AdminApiService } from '../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpiposition, kpi, bmoutgoing, bmincomingattendees, bmInOutGoingStatusHistroy, filecontent } from '../../../models/slakpi';
import { division, department } from '../../../models/admin';
import { formatDate } from '@angular/common';
import { uniqBy } from 'lodash';
import { ToasterService } from '../../../toaster.service';
@Component({
  selector: 'app-bench-mark-outgoing',
  templateUrl: './bench-mark-outgoing.component.html',
  styleUrls: ['./bench-mark-outgoing.component.css']
})
export class BenchMarkOutgoingComponent implements OnInit {
  objBMIncomingAttendees = new bmincomingattendees();
  objBM: any = new bmoutgoing();
  selTab: boolean = true;
  submitted: boolean = false;
  public filterApprovalCount: number = 0;
  columnAtdDefinitions: Column[];
  atdGrid: AngularGridInstance;
  datasetAtd: any;
  invalid: boolean = false;
  public visitor_data: any;
  public organizationType_data: any;  
  public division_data: any;
  public department_data: any;
  public letterStatus_data: any;
  public MDCEOResponse_data: any;
  public LogisticStatus_data: any;
  public VisitStatus_data: any;
  public Delegated_data: any;
  public benchMarkYear_data: any;
  public currentHalf_data: any;
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  @ViewChild('addAttendeeTemplate', { static: false }) addAttendeeTemplate: TemplateRef<any>;

  @ViewChild('statusUpdateTemplate', { static: false }) statusUpdateTemplate: TemplateRef<any>;
  @ViewChild('lessionUpdateTemplate', { static: false }) lessionUpdateTemplate: TemplateRef<any>;
  @ViewChild('statusUpdateHistroyTemplate', { static: false }) statusUpdateHistroyTemplate: TemplateRef<any>; 
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  yearfilter: any;
  divisionUnofilter: any;
  halffilter: any;
  positionfilter: any;
  angularGrid: AngularGridInstance;
  public BMIncoming_data: any;
  public loading: boolean = true;
  public pageAction: string = 'add';
  isStart: boolean = true;
  public filterDataCollectionCount: number = 0;
  public filterOverdueCount: number = 0;
  public filterCompletedCount: number = 0;
  public filterAll_classactive: string = '';
  public filterDataCollection_classactive: string = 'active';
  public filterOverdue_classactive: string = '';
  public filterCompleted_classactive: string = '';
  public filterApproval_classactive: string = '';
  public tranBenchMarkKPIHistory_data: any;
  public learntLessons: string = '';
  objTranBenchmarkKPI: any = new tranbenchmarkkpi();
  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean;
  statusUno: number = 1;
  position_data: any;

  selectedItem: any;
  public uploadedFiles: Array<File> = [];
  surveyDD = [{ id: 1, survey: "survey1" }, { id: 2, survey: "survey2" }, { id: 3, survey: "survey3" }, { id: 4, survey: "survey4" }, { id: 5, survey: "survey5" }];
  btnText: string = 'Add';
    searchText: string;
  dataSearch: any;
  statusDDList = [
    { value: 0, text: 'Draft' },
    //{ value: 1, text: 'In Progress' },
    { value: 2, text: 'Approved' },
    { value: 2, text: 'On Hold' },
    { value: 4, text: 'Rejected' },
    //{ value: 5, text: 'Conducted' },
    //{ value: 6, text: 'Conducted (virtual)' },
    //{ value: 7, text: 'No Response' },
    //{ value: 8, text: 'Scheduled' }
  ];

 

  dataHistroy: any;
  bmRequestStatusHistroyDataSet: any[];
  histroyColumnDefinitions: any;
  editID: any;
  yesNoList = [{ value: 1, text: 'Yes' }, { value: 0, text: 'No' }]

  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false
  outgoingID: any;
  noDataImg: any;
  tenantUno: any;
    filterDepartment_Data: any;
  visitTrackno: any;
  AttachmentList: any;
  fileItemCount: any;
  fileContent: any;
  constructor(public restApi: BMApiService, public restAdminApi: AdminApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission

  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Outgoing / Internal BM Request");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;

    this.gridOptions = {

      //autoHeight: true,
      //enableAutoResize: true,
      //enablePagination: true,
      //pagination: {
      //  pageSizes: [20, 50, 100,200, 500,1000,1500,2000],
      //  pageSize: 20
      //},
      //enableFiltering: true,
      //alwaysShowVerticalScroll: false,
      //enableRowSelection: true,
      //autoResize: {
      //  containerId: 'musherat-grid',
      //  delay: 0,
      //  sidePadding: 10,
      //  bottomPadding: 10
      //},
      //enableExcelExport: true,
      //enableExcelCopyBuffer: true,
      //enableFilterTrimWhiteSpace: true,
      //showCustomFooter: true, // display some metrics in the bottom custom footer
      //enableContextMenu: true,
      //enableCellMenu: true,
      //forceFitColumns: true,

      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [20, 50, 100, 200, 500, 1000, 1500, 2000],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: false,
    };
    
    this.LoadBMOuting();
    //this.loadBenckMarkKPIInboxCount();

    this.getVisitorFrom();
    this.getOrganizationType();
    this.getDivisions();
    this.getLetterStatus();
    this.getMDCEOResponse();
    this.getLogisticStatus();
    this.getVisitStatus();
    this.getISDelegated();
    this.getDepartments();
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  angularAtdGridReady(angularGrid: AngularGridInstance) {
    this.atdGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  
  getVisitorFrom() {
    

    this.visitor_data = [
      {text: 'Local', value: 1 },
      { text: 'International', value: 3 },
      
    ];
  }
  getOrganizationType() {
    

    this.organizationType_data = [
      { text: 'Government', value: 1 },
      { text: 'Semi Government', value: 2 },
      { text: 'Private', value: 3 },
      { text: 'Not Applicable', value: 4 },

    ];
  }
  getLetterStatus() {
    this.letterStatus_data = [
      { text: 'Pending', value: 1 },
      { text: 'Approved', value: 1 },
      { text: 'Rejected', value: 1 }
      //{ text: 'Completed', value: 2 },
      //{ text: 'Conducted', value: 3 }
    ];
  }

  getMDCEOResponse() {
    this.MDCEOResponse_data = [
      { text: 'Approve', value: 1 },
      { text: 'Rejecet', value: 2 }
    ];
  }

  getLogisticStatus() {
    this.LogisticStatus_data = [
      { text: 'In Progress', value: 1 },
      { text: 'Pending', value: 2 },
      { text: 'Completed', value: 3 }
    ];
  }
  getVisitStatus() {
    this.VisitStatus_data = [
      { text: 'In Progress', value: 1 },
      { text: 'Scheduled', value: 2 },      
      { text: 'On Hold', value: 3 },
      { text: 'No Response', value: 4 },
      { text: 'Rejected by the peer', value: 5 },
      { text: 'Conducted', value: 6},
    ];
  }
  getISDelegated() {
    this.Delegated_data = [
      { text: 'Yes', value: 1 },
      { text: 'No', value: 2 }
    ];
  }
  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {

        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getDepartments() {

    let inpValue = new department();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    this.restApi.getDepartments(inpValue)
      .subscribe(data => {
        
        this.department_data = data;
        this.filterDepartment_Data = this.department_data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  onChangeDivision(e) {
    
    this.filterDepartment_Data = [];
    let divisionName = (this.objBM.division != '' && this.objBM.division != undefined) ? this.objBM.division:'';
    let divisionUno = this.division_data.filter(item => item.divisionNameEn === divisionName)[0].divisionUno;
    
      this.filterDepartment_Data = this.department_data.filter(item => item.divisionUno === divisionUno);

    if (this.filterDepartment_Data.length == 0) {
      this.filterDepartment_Data = this.department_data;
    }
  }

  getAttendee(id) {
    let inpValue = new bmincomingattendees();
    inpValue.visitTrackUno = id;
    inpValue.userUno = this.login_UserID;
    this.restApi.getBMOutgoinngAtd(inpValue)
      .subscribe(data => {
        this.datasetAtd = data;
        this.setAtdDefn();
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  setAtdDefn() {
    this.columnAtdDefinitions = [
      { id: 'firstName', name: 'First Name', field: 'firstName', sortable: true },
      { id: 'lastName', name: 'Last Name', field: 'lastName', sortable: true },
      { id: 'email', name: 'Email', field: 'email', sortable: true },
      { id: 'mobileNumber', name: 'Mobile Number', field: 'mobileNumber', sortable: true },
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [

            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-lg fa-edit', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                let rdata: any = args.dataContext;
                this.objBMIncomingAttendees = new bmincomingattendees();
                this.objBMIncomingAttendees = rdata;
                this.btnText = 'Update';
              },
              //  // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },
            {
              command: 'atd-row', titleKey: 'atd_ROW', positionOrder: 64, title: 'Delete',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-lg fa-trash', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'view';
                let rdata: any = args.dataContext;
                this.objBMIncomingAttendees = new bmincomingattendees();
                this.objBMIncomingAttendees = rdata;

                Swal.fire({
                  text: 'Please confirm to delete',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.objBM.isActive = 0;
                    this.delAttendees();
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                  }
                })

              },
              //  // only show command to 'Delete Row' when the task is not completed

            },
          

          ],
        }
      }
    ];
  }
  cancelAttendee(val) {
    this.objBMIncomingAttendees = new bmincomingattendees();
    this.btnText = 'Add';
    val.submitted = false;
  }

  searchKPIRelease() {
    
    let temp = this;
    this.spinner.show();
    if (!this.isStart) {
      setTimeout(function () { temp.LoadBMOuting(); }, 1000)

    }

  }

  openModalWithClass(addtemplate: TemplateRef<any>) {
    this.pageAction = "add";
    this.objBM = new bmoutgoing();
    this.selTab = true;
    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  LoadBMOuting() {
    

    let inpValue = new bmoutgoing();
    inpValue.id = 1033;
    inpValue.visitTrackUno = 0;
    inpValue.condition = 0;
    inpValue.enteredBy = this.login_UserID.toString();
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getBMOutgoinng(inpValue)
      .subscribe((data: any) => {
        
        let rtn_data = data;
        const mockDataset = [];
        this.dataset = [];
        
        if (rtn_data != null && rtn_data.length > 0) {

          for (let i = 0; i < rtn_data.length; i++) {

            mockDataset[i] = {
              id: rtn_data[i].id,
              visitTrackUno: rtn_data[i].visitTrackUno,
              division: rtn_data[i].division,
              organizationType: rtn_data[i].organizationType,
              department: rtn_data[i].department,
              requestedBy: rtn_data[i].requestedBy,
              submittedApprovedVisitForm: rtn_data[i].submittedApprovedVisitForm,
              receivedRequestOn: rtn_data[i].receivedRequestOn,
              year: (formatDate(rtn_data[i].visitorRemoteMeetingDate, 'yyyy', 'en-US') == '9999') ? '-' : formatDate(rtn_data[i].visitorRemoteMeetingDate, 'yyyy', 'en-US'),
              organizationName: rtn_data[i].organizationName,
              visitFrom: rtn_data[i].visitFrom,
              purposeorSubject: rtn_data[i].purposeorSubject,
              letterStatusSmartDocument: rtn_data[i].letterStatusSmartDocument,
              submittedSmartDocumentOn: rtn_data[i].submittedSmartDocumentOn,
              referenceNo: rtn_data[i].referenceNo,
              requestStatus: (rtn_data[i].requestStatus == '') ? '-' : rtn_data[i].requestStatus.trim(),
              sentTargetedOrganizationOn: rtn_data[i].sentTargetedOrganizationOn,
              receivedResponse: rtn_data[i].receivedResponse,
              responseFrom: rtn_data[i].responseFrom,
              visitorRemoteMeetingStatus: (rtn_data[i].visitorRemoteMeetingStatus == '') ? '-' : rtn_data[i].visitorRemoteMeetingStatus,
              visitorRemoteMeetingDate: rtn_data[i].visitorRemoteMeetingDate,
              submittedAfter: rtn_data[i].submittedAfter,
              learntLessons: rtn_data[i].learntLessons,
              capturedBenefits: rtn_data[i].capturedBenefits,
              isActive: rtn_data[i].isActive,
              enteredBy: rtn_data[i].enteredBy,
             //quarter: rtn_data[i].quarter,
               
              TargetedOrganizationOn: rtn_data[i].sentTargetedOrganizationOn.split("-"),
            
              fsentTargetedOrganizationOn: (formatDate(rtn_data[i].sentTargetedOrganizationOn, 'yyyy', 'en-US') != '9999') ? formatDate(rtn_data[i].sentTargetedOrganizationOn, 'dd-MM-yyy', 'en-US') : '-',
              fvisitorRemoteMeetingDate: (formatDate(rtn_data[i].visitorRemoteMeetingDate, 'yyyy', 'en-US') != '9999') ? formatDate(rtn_data[i].visitorRemoteMeetingDate, 'dd-MM-yyy', 'en-US') : '-',
             
              quarter: (formatDate(rtn_data[i].visitorRemoteMeetingDate, 'dd-MM-yyyy', 'en-US') != '01-01-9999') ? rtn_data[i].quarter : '-',
            }
          }
          
          this.dataSearch = mockDataset;
          this.dataset = mockDataset;
          if (mockDataset.length > 0) {
            this.setColnDefn();
          }
          this.BMIncoming_data = rtn_data;
         
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
        else {
          this.dataset = [];
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
      },
        (error) => {
          //Called when error
        }
      ).add(() => {                                    
        //Called when operation is complete (both success and error)
      });
  }

  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.division && a.division.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.department && a.department.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.visitFrom && a.visitFrom.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.organizationType && a.organizationType.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.requestStatus && a.requestStatus.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.purposeorSubject && a.purposeorSubject.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.quarter && a.quarter.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.organizationName && a.organizationName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.visitorRemoteMeetingDate && a.visitorRemoteMeetingDate.toLowerCase().includes(this.searchText.toLowerCase()))
      );
    }
    else
      this.dataset = this.dataSearch;
  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue',
        //width: 20,
        minWidth: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [

            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-lg fa-edit', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                
                this.pageAction = 'edit';
                let rdata: any = args.dataContext;
                this.visitTrackno = rdata.visitTrackUno;
                this.objBM = new bmoutgoing();
                this.objBM = rdata;
                this.objBM.submittedAfter = rdata.submittedAfter;
                //this.objBM.receivedRequestOn = formatDate(this.objBM.receivedRequestOn, 'yyyy-MM-dd', 'en-US');

                this.objBM.receivedRequestOn = (this.objBM.receivedRequestOn != undefined && this.objBM.receivedRequestOn != "") ? formatDate(this.objBM.receivedRequestOn, 'yyyy-MM-dd', 'en-US') : '';
                this.objBM.receivedRequestOn = (this.objBM.receivedRequestOn == "9999-01-01") ? '' : this.objBM.receivedRequestOn;


                //this.objBM.submittedSmartDocumentOn = formatDate(this.objBM.submittedSmartDocumentOn, 'yyyy-MM-dd', 'en-US');


                this.objBM.submittedSmartDocumentOn = (this.objBM.submittedSmartDocumentOn != undefined && this.objBM.submittedSmartDocumentOn != "") ? formatDate(this.objBM.submittedSmartDocumentOn, 'yyyy-MM-dd', 'en-US') : '';
                this.objBM.submittedSmartDocumentOn = (this.objBM.submittedSmartDocumentOn == "9999-01-01") ? '' : this.objBM.submittedSmartDocumentOn;

                // this.objBM.sentTargetedOrganizationOn = formatDate(this.objBM.sentTargetedOrganizationOn, 'yyyy-MM-dd', 'en-US');

                this.objBM.sentTargetedOrganizationOn = (this.objBM.sentTargetedOrganizationOn != undefined && this.objBM.sentTargetedOrganizationOn != "") ? formatDate(this.objBM.sentTargetedOrganizationOn, 'yyyy-MM-dd', 'en-US') : '';
                this.objBM.sentTargetedOrganizationOn = (this.objBM.sentTargetedOrganizationOn == "9999-01-01") ? '' : this.objBM.sentTargetedOrganizationOn;


                //this.objBM.visitorRemoteMeetingDate = formatDate(this.objBM.visitorRemoteMeetingDate, 'yyyy-MM-dd', 'en-US');

                this.objBM.visitorRemoteMeetingDate = (this.objBM.visitorRemoteMeetingDate != undefined && this.objBM.visitorRemoteMeetingDate != "") ? formatDate(this.objBM.visitorRemoteMeetingDate, 'yyyy-MM-dd', 'en-US') : '';
                this.objBM.visitorRemoteMeetingDate = (this.objBM.visitorRemoteMeetingDate == "9999-01-01") ? '' : this.objBM.visitorRemoteMeetingDate;

                this.modalRef = this.modalService.show(
                  this.addtemplate,
                  Object.assign({}, {
                    class: 'gray modal-lg',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );
                this.uploadedFiles = [];

                this.getFiles(rdata.visitTrackUno);

              },
              //  // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Update Status',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-refresh', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.visitTrackUno;
                this.objBM = rdata;
                this.objBM.requestStatus = rdata.requestStatus;
                this.modalRef = this.modalService.show(
                  this.statusUpdateTemplate,
                  Object.assign({}, { class: 'gray modal-medium' })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 64 },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 65, title: 'Update Lessons Learnt',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (data.requestStatus == 'Approved' && !this.isBMVisitor)
                  return true;
                else return false;
              },
              iconCssClass: 'fa fa-edit', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.visitTrackUno;
                this.objBM = rdata;
                this.learntLessons = rdata.learntLessons;
                this.modalRef = this.modalService.show(
                  this.lessionUpdateTemplate,
                  Object.assign({}, { class: 'gray modal-sm' })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 66 },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 66, title: 'Status History',
              iconCssClass: 'fa fa-lg fa-info-circle', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.visitTrackUno;
                this.loadBMIncomingStatusHistroy();
                this.objBM.comments = '';
                this.modalRef = this.modalService.show(
                  this.statusUpdateHistroyTemplate,
                  Object.assign({}, { class: 'gray modal-lg' })
                );
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            {
              command: 'atd-row', titleKey: 'atd_ROW', positionOrder: 67, title: 'Delete',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-lg fa-trash', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'view';
                let rdata: any = args.dataContext;
                this.objBM = new bmoutgoing();
                this.objBM = rdata;

                Swal.fire({
                  text: 'Please confirm to delete',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.objBM.isActive = 0;
                    this.AddEditBMOutgoing(this.objBM);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                  }
                })

              },
              //  // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 68 },

            //{
            //  command: 'atd-row', titleKey: 'atd_ROW', positionOrder: 69, title: 'Attendee',
            //  itemVisibilityOverride: (args: MenuCallbackArgs) => {
            //    let data = args.dataContext;

            //    if (this.isBMTeam || this.isBMVisitor)
            //      return false;
            //   // else return true;
            //  },
            //  iconCssClass: 'fa fa-lg fa-user-circle', cssClass: 'blue', textCssClass: 'bold',
            //  action: (e, args) => {
            //    this.pageAction = 'view';
            //    let rdata: any = args.dataContext;
            //    this.objBM = new bmoutgoing();
            //    this.objBM = rdata;
            //    this.getAttendee(this.objBM.visitTrackUno);

            //    this.modalRef = this.modalService.show(
            //      this.addAttendeeTemplate,
            //      Object.assign({}, {
            //        class: 'gray modal-lg',
            //        backdrop: true,
            //        keyboard: true,
            //        focus: true,
            //        show: false,
            //        ignoreBackdropClick: true,
            //        animated: true
            //      })
            //    );

            //  },
            //  //  // only show command to 'Delete Row' when the task is not completed

            //},

          ],
        }
      },
      {

        id: 'division', name: 'Division', field: 'division', sortable: true,
        minWidth: 300,
        //width: 50,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data1) => {
          let per = data1.division;
          return '<div title="' + per + '">' + per + '</div>'
         
        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'division', 'division'),
          model: Filters.multipleSelect,
        }
      },
      //{
      //  id: 'department', name: 'Department', field: 'department', sortable: true, width: 50,
      //  type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'department', 'department'),
      //    model: Filters.multipleSelect,
      //  }
      //},
     
      
      {
        id: 'organizationName', name: 'Organization Name', field: 'organizationName', sortable: true,
        //width: 120,
        minWidth: 200,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data1) => {
          let per = data1.organizationName;
          return '<div title="' + per + '">' + per + '</div>'

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'organizationName', 'organizationName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'organizationType', name: 'Organization Sector', field: 'organizationType', sortable: true,
       // width: 90,
        minWidth: 150,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'organizationType', 'organizationType'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'visitFrom', name: 'Level', field: 'visitFrom', sortable: true,
        //width: 50,
        minWidth: 150,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'visitFrom', 'visitFrom'),
          model: Filters.multipleSelect,
        }
      },
      
      //{
      //  id: 'receivedRequestOn', name: 'Received On', field: 'receivedRequestOn', sortable: true,
      //  type: FieldType.string, filterable: true,
      //  formatter: (row, cell, val, columnDef, dataContext) => {
     
      //      return formatDate(dataContext.receivedRequestOn, 'dd-MM-yyyy', 'en-US');
        
      //  },
       
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'receivedRequestOn', 'receivedRequestOn'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      
      {
        id: 'purposeorSubject', name: 'Subject', field: 'purposeorSubject', sortable: true,
       // width: 50,
        minWidth: 250,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data1) => {
          let per = data1.purposeorSubject;
          return '<div title="' + per + '">' + per + '</div>'

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'purposeorSubject', 'purposeorSubject'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'year', name: 'Year', field: 'year', sortable: true,
        //width: 50,
        minWidth: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'year', 'year'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'requestSentOn', name: 'Request Sent On', field: 'fsentTargetedOrganizationOn', sortable: true,
        //width: 90,
        minWidth: 150,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'fsentTargetedOrganizationOn', 'fsentTargetedOrganizationOn'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'fvisitRemoteMeetingDate', name: 'Benchmarking Meeting Date', field: 'fvisitorRemoteMeetingDate', sortable: true,
        //width: 150,
        minWidth: 200,
        type: FieldType.string, filterable: true,       
        filter: {
          collection: this.uniqueArray(this.dataset, 'fvisitorRemoteMeetingDate', 'fvisitorRemoteMeetingDate'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'quarter', name: 'Quarter', field: 'quarter', sortable: true,
        //width: 50,
        minWidth: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'quarter', 'quarter'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'requestStatus', name: 'Request Status', field: 'requestStatus', sortable: true,
        //width: 90,
        minWidth: 150,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data) => {
          if (data.requestStatus == 'Draft' || data.requestStatus == '')
            return '<span  class="status-area status-yellow">Draft</span>';
          else if (data.requestStatus == 'Approved')
            return '<span  class="status-area status-green">Approved</span>';

          else if (data.requestStatus == 'On Hold')
            return '<span  class="status-area status-orange">On Hold</span>';
          else if (data.requestStatus == 'Rejected')
            return '<span  class="status-area status-red">Rejected</span>';
          else if (data.requestStatus == 'Conducted')
            return '<span  class="status-area status-green">Conducted</span>';
          else if (data.requestStatus == 'Conducted (virtual)')
            return '<span  class="status-area status-green">Conducted (virtual)</span>';
          else if (data.requestStatus == 'No Response')
            return '<span  class="status-area status-red">No Response</span>';
          else if (data.requestStatus == 'In Progress')
            return '<span  class="status-area status-orange">In Progress</span>';
          else if (data.requestStatus == 'Scheduled')
            return '<span  class="status-area status-yellow">Scheduled</span>';

         

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'requestStatus', 'requestStatus'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'visitorRemoteMeetingStatus', name: 'BM Meeting Status', field: 'visitorRemoteMeetingStatus', sortable: true,
        //width: 50,
        minWidth: 150,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'visitorRemoteMeetingStatus', 'visitorRemoteMeetingStatus'),
          model: Filters.multipleSelect,
        }
      }
      
      
      
      


    ]


  }
  onDbClicked(ev, args) {
    
   //    this.router.navigateByUrl('/benchmarkkpiview/' + rdata.id);
    return false;
  }


  getViewHistory(id: number) {
    

    let inpValue = new tranbenchmarkkpihistory();

    inpValue.itemUno = id;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    this.restApi.getTranBenchMarkKPIHistory(inpValue)
      .subscribe(data => {
        
        this.tranBenchMarkKPIHistory_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

  }


  onfilterData(type: any) {
    if (type == 'data')
      this.statusUno = 1;
    if (type == 'approval')
      this.statusUno = 2;
    if (type == 'completed')
      this.statusUno = 5;

    //this.LoadTranBenchmarkKPI();
  }

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }

  addAttendees(val) {
    
   
    if (!val.form.valid) {
      //Swal.fire('Error', 'Please enter the all required fileds.', 'error');
      this.toaster.show('error', 'Error', 'Please enter the all required fileds.');
      return;
    }
    this.objBMIncomingAttendees.visitTrackUno = this.objBM.visitTrackUno;
    this.objBMIncomingAttendees.condition = 0;
    this.objBMIncomingAttendees.userUno = this.login_UserID;
    this.restApi.AddEditBMOutgoinngAttendee(this.objBMIncomingAttendees)
      .subscribe(data => {
        this.toaster.show('success', 'Success', 'Attendee is saved.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'Attendee is saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})

          this.objBMIncomingAttendees = new bmincomingattendees();
          val.submitted = false;
          this.btnText = 'Add';
          this.getAttendee(this.objBM.visitTrackUno);
        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
   
  }
  delAttendees() {
    
    this.objBMIncomingAttendees.condition = 5;
    this.objBMIncomingAttendees.userUno = this.login_UserID;
    this.restApi.AddEditBMOutgoinngAttendee(this.objBMIncomingAttendees)
      .subscribe(data => {
        this.toaster.show('success', 'Success', 'Attendee is deleted.');
        //Swal.fire({
        //  type: 'success',
        //  title: 'Attendee is deleted.',
        //  showConfirmButton: false,
        //  timer: 1500
        //})
        this.getAttendee(this.objBM.visitTrackUno);
        this.objBMIncomingAttendees = new bmincomingattendees();
      

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });

  }
  onNext(val) {
    if (this.uploadedFiles && this.uploadedFiles.length > 0) {
      //Check file count 
      if (this.uploadedFiles.length > 5) {
        this.toaster.show('error', 'Error', 'Status - Maximum 5 Files to be upload');
        return false;
      }

      for (var i = 0; i < this.uploadedFiles.length; i++) {
        let fileName = this.uploadedFiles[i].name.toLowerCase();
        let fileSize = this.uploadedFiles[i].size;
        //Check file size
        if (!this.userService.checkFileSize(fileSize)) {
          this.toaster.show('error', 'Error', 'Status - A file size should not above 30MB.');
          return false;
        }
        //To check file exe
        if (!this.userService.checkFileValuranabity(fileName, fileSize)) {
          this.toaster.show('error', 'Error', 'Status - Please select the correct formate file');
          return false;
        }
      }
    }
    if (val) {
    this.AddEditBMOutgoing(this.objBM)
    }else
     {
      Swal.fire('Error', 'Please enter required values.', 'error')
    }
  }
  
  AddEditBMOutgoing(data1: any) {
    
    let objBM = new bmoutgoing();
    objBM = data1
    objBM.requestedBy = (objBM.requestedBy != null && objBM.requestedBy != undefined) ? objBM.requestedBy : '';
    objBM.referenceNo = (objBM.referenceNo != null && objBM.referenceNo != undefined) ? objBM.referenceNo : '';
    objBM.responseFrom = (objBM.responseFrom != null && objBM.responseFrom != undefined) ? objBM.responseFrom : '';
    objBM.submittedAfter = (objBM.submittedAfter != null && objBM.submittedAfter != undefined) ? objBM.submittedAfter : '';
    objBM.capturedBenefits = '';

    objBM.receivedRequestOn = (objBM.receivedRequestOn != null && objBM.receivedRequestOn != undefined && objBM.receivedRequestOn != '') ? this.objBM.receivedRequestOn : new Date("9999-01-01");

    objBM.submittedSmartDocumentOn = (objBM.submittedSmartDocumentOn != null && objBM.submittedSmartDocumentOn != undefined && objBM.submittedSmartDocumentOn != '') ? this.objBM.submittedSmartDocumentOn : new Date("9999-01-01");

    objBM.visitorRemoteMeetingDate = (objBM.visitorRemoteMeetingDate != null && objBM.visitorRemoteMeetingDate != undefined && objBM.visitorRemoteMeetingDate != '') ? this.objBM.visitorRemoteMeetingDate : new Date("9999-01-01");

    objBM.sentTargetedOrganizationOn = (objBM.sentTargetedOrganizationOn != null && objBM.sentTargetedOrganizationOn != undefined && objBM.sentTargetedOrganizationOn != '') ? this.objBM.sentTargetedOrganizationOn : new Date("9999-01-01");
    

    objBM.requestStatus = (this.pageAction == "edit") ? this.objBM.requestStatus : 'Draft';
      objBM.enteredBy = this.login_UserID.toString();
    objBM.condition = (this.pageAction == "add") ? 0 : 1;
    if (this.pageAction == 'delete') {
      objBM.condition = 2;
    }
    objBM.tenantUno = this.tenantUno;
    this.restApi.addEditBMOutgoinng(objBM)
        .subscribe(data => {
          
          if (data != null && data != undefined  && data == 'failure') {
            //Swal.fire('Error', 'Something went wrong', 'error');
            this.toaster.show('error', 'Error', 'Something went wrong.');
            this.spinner.hide();
           
          }
          else {

            this.outgoingID = data;
            this.saveFile();
            if (this.pageAction == 'delete')
              this.toaster.show('success', 'Success', 'BM Outgoing logs deleted.');


            else {
              this.toaster.show('success', 'Success', 'BM Outgoing logs saved.');


              this.modalRef.hide();

            }
            setTimeout(() => { this.spinner.hide(); this.LoadBMOuting(); }, 900);
            

          }



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return true;
    }

  onStatusSubmit(val1) {
    
    if (!val1) {
      this.toaster.show('error', 'Error', 'Please enter all the required fields in General Information tab.');
      return
    }

    else {
      this.updateBMStatus();
    }
  }

  onupdateLesson() {
    
    let objBM = new bmoutgoing();
    objBM = this.objBM;
    objBM.learntLessons = this.learntLessons.trimEnd();
    //check empty value
    if (objBM.learntLessons != '') {


      objBM.requestedBy = (objBM.requestedBy != null && objBM.requestedBy != undefined) ? objBM.requestedBy : '';
      objBM.requestedBy = (objBM.referenceNo != null && objBM.referenceNo != undefined) ? objBM.referenceNo : '';
      objBM.responseFrom = (objBM.responseFrom != null && objBM.responseFrom != undefined) ? objBM.responseFrom : '';
      objBM.submittedAfter = (objBM.submittedAfter != null && objBM.submittedAfter != undefined) ? objBM.submittedAfter : '';
      objBM.capturedBenefits = '';
      objBM.receivedRequestOn = (objBM.receivedRequestOn != null && objBM.receivedRequestOn != undefined) ? this.objBM.receivedRequestOn : new Date("9999-01-01");
      objBM.submittedSmartDocumentOn = (objBM.submittedSmartDocumentOn != null && objBM.submittedSmartDocumentOn != undefined) ? this.objBM.submittedSmartDocumentOn : new Date("9999-01-01");
      //objBM.requestStatus = (this.editID != null && this.editID != undefined) ? this.objBM.requestStatus : 'Draft';
      objBM.enteredBy = this.login_UserID.toString();
      objBM.condition = 3;
      this.restApi.addEditBMOutgoinng(objBM)
        .subscribe(data => {
          
          if (data != null && data != undefined && data == 'failure') {

            //Swal.fire('Error', 'Something went wrong', 'error');
            this.toaster.show('error', 'Error', 'Something went wrong.');
            this.spinner.hide();
            
          }
          else {
            this.toaster.show('success', 'Success', 'Lessons learnt updated.');

            this.modalRef.hide();

            setTimeout(() => { this.spinner.hide(); this.LoadBMOuting(); }, 900);

          }



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return true;
    }
    else {
      this.modalRef.hide();
      return false;
    }
  }
  updateBMStatus() {
    

    let obj = new bmoutgoing();
    obj.id = (this.editID) ? this.editID : 0;
    obj.comments = (this.objBM.comments) ? this.objBM.comments : '';
    obj.requestStatus = this.objBM.requestStatus;
    obj.organizationType = this.objBM.organizationType;
    obj.visitFrom = this.objBM.visitFrom;
    obj.organizationType = this.objBM.organizationType;
    obj.purposeorSubject = this.objBM.purposeorSubject;
    obj.userID = this.login_UserID;
    obj.flag = 'bmoutgoing';
    this.restApi.updateBMOutgoingStatus(obj)
      .subscribe(data => {

        if (data != null && data != undefined && data != '' && data != 'failure') {
          this.toaster.show('success', 'Success', 'Status updated.');
          setTimeout(() => {
            this.objBM = new bmoutgoing();
            this.spinner.hide();
            this.LoadBMOuting();
            this.modalRef.hide();
          }, 500);

        }
        else {

          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();

        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
    return true;

  }
  loadBMIncomingStatusHistroy() {
    this.spinner.show();
    let inpValue = new bmInOutGoingStatusHistroy();
    inpValue.flag = 'bmoutgoing';
    inpValue.id = (this.editID) ? this.editID : 0;
    inpValue.userUno = this.login_UserID;

    this.restApi.getBMInOutGoingStatus(inpValue)
      .subscribe(data => {
        

        this.dataHistroy = uniqBy(data, 'id');
        const mockDataset = [];
        for (let i = 0; i < this.dataHistroy.length; i++) {

          mockDataset[i] = {
            id: this.dataHistroy[i].id,
            reqNo: this.dataHistroy[i].reqNo,
            comments: this.dataHistroy[i].comments,
            status: this.dataHistroy[i].status,
            enteredBy: this.dataHistroy[i].enteredBy,
            enteredOn: this.dataHistroy[i].enteredOn,
            createdBy: this.dataHistroy[i].createdBy

          };
        }
        this.bmRequestStatusHistroyDataSet = mockDataset;
        if (mockDataset.length > 0) {
          this.setGridBMIncomingStatusHistroyDefn();
        }
        else {
          this.setGridBMIncomingStatusHistroyDefn();
        }

        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  setGridBMIncomingStatusHistroyDefn() {
    let temp = this;
    this.histroyColumnDefinitions = [
      {
        id: 'status', name: 'Status', field: 'status', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'status', 'status'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'comments', name: 'Comments', field: 'comments', sortable: true, type: FieldType.string, filterable: false, width: 120,
        filter: {
          collection: this.uniqueArray(this.dataset, 'comments', 'comments'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'createdBy', name: 'Action By', field: 'createdBy', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'enteredOn', 'enteredOn'),
          model: Filters.multipleSelect,

        }
      },

      

      {
        id: 'enteredOn', name: 'Action Date', field: 'enteredOn', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'enteredOn', 'enteredOn'),
          model: Filters.multipleSelect,

        }
      },


    ]


  }

  //saveFile() {
  //  if (this.uploadedFiles && this.uploadedFiles.length > 0) {
  //    if (this.uploadedFiles.length > 5) {
  //      this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload');
  //      return false;
  //    }
  //    let formData = new FormData();
  //    let isFileReadyForUpload = false;
  //    for (var i = 0; i < this.uploadedFiles.length; i++) {
  //      let allowFile = false;
  //      let fileName = this.uploadedFiles[i].name.toLowerCase();
  //      let fileSize = this.uploadedFiles[i].size;
  //      //To check filee size exe
  //      allowFile = this.userService.checkFileValuranabity(fileName, fileSize);

  //      if (allowFile) {
  //        formData.append("file", this.uploadedFiles[i]);
  //        isFileReadyForUpload = true;
  //      }
  //    }
  //    if (isFileReadyForUpload) {
  //      formData.append("id", this.outgoingID);
  //      formData.append("flag", "BMOutoing");
  //      formData.append("userUno", this.login_UserID.toString());
  //      this.restApi.fileManagerFileUpload(formData)
  //        .subscribe(data => {
  //          
  //          if (data == null && data == undefined && data == '') {

  //          }
  //          else {
  //            //  this.toaster.show('success', 'Success', 'File uploaded.');
  //            //this.RefreshDirectory();
  //            //this.selectedRecord = new fileManager();
  //            this.uploadedFiles = [];


  //          }

  //          this.spinner.hide();
  //        },
  //          (error) => {
  //            this.spinner.hide();
  //          }
  //        ).add(() => {
  //          this.spinner.hide();
  //        });
  //    }
  //  }
  //  //else {
  //  //  this.toaster.show('error', 'Error', 'Please select the file');
  //  //}
  //}

  
  saveFile() {

    this.spinner.show();
    if (this.uploadedFiles.length > 5) {
      this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload');
      return false;
    }
    for (var i = 0; i < this.uploadedFiles.length; i++) {
      let allowFile = false;
      let fileName = this.uploadedFiles[i].name.toLowerCase();
      let fileSize = this.uploadedFiles[i].size;
      //Check file size
      let allowFileSize = false;
      allowFileSize = this.userService.checkFileSize(fileSize);
      if (!allowFileSize) {
        this.toaster.show('error', 'Error', 'A file size should not above 30MB.');
        return;
      }
      //To check filee size exe  
      allowFile = this.userService.checkFileValuranabity(fileName, fileSize);

      if (allowFile) {

        this.restApi.BMOutgoingFileUpload(this.uploadedFiles[i], this.uploadedFiles[i].name, this.visitTrackno).subscribe(data => {

          this.spinner.hide();
        },
          (error) => {
            //Called when error
            // Swal.fire('Error', 'Something went wrong', 'error')
            this.toaster.show('error', 'Error', 'Something went wrong.');
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          this.spinner.hide();
        });
      }
    }


  }

  onClickAttachment(visitTrackno: string): void {
    
    this.getFiles(visitTrackno);
  }


  getFiles(visitTrackUno: string) {

    
    this.AttachmentList = null;
    let inpValue = new filecontent();
    inpValue.masterUNo = visitTrackUno;
    inpValue.itemUNo = '0';
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.visitTrackno = visitTrackUno;
    this.restApi.BMOutgoing_FileSelect(inpValue)
      .subscribe(data => {
        this.AttachmentList = data;
        this.fileItemCount = (this.AttachmentList != undefined && this.AttachmentList != null) ? this.AttachmentList.length : 0;
        this.spinner.hide();

      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });
  }

  DeleteAttachment(itemUno: string) {

    //});
    let inpValue = new filecontent();
    inpValue.masterUNo = this.visitTrackno;
    inpValue.itemUNo = itemUno;
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.restApi.BMOutgoing_FileDelete(inpValue)
      .subscribe(data => {
        this.getFiles(this.visitTrackno);
        //setTimeout(() => { this.spinner.hide(); this.loadSLA(); }, 1100);
      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });
  }
  AttachmentDownload(id: any, name: string) {
    let inpValue = new filecontent();
    inpValue.masterUNo = this.visitTrackno;
    inpValue.itemUNo = id;
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.restApi.BMOutgoing_Filedownload(inpValue).subscribe(
      data => {
        
        this.spinner.hide();
        if (data != null) {
          
          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            window.navigator.msSaveBlob(data, name);
          }
          else //Chrome & FF
          {
            var url = window.URL.createObjectURL(data);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
          }

        }
        else {
          this.spinner.hide();
          //Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
      },
      error => {
        //Swal.fire('Error', 'Something went wrong', 'error')
        this.toaster.show('error', 'Error', 'Something went wrong.');
        this.spinner.hide();
      },
      () => {
        // 'onCompleted' callback.
        this.spinner.hide();

      }
    );

  }
  getFileIconClass(fileTitle: string) {

    if (fileTitle == '' || fileTitle == null)
      return "fa fa-file";

    var rtnClass = "fa fa-file";
    var strTitle = (fileTitle.indexOf('.') > 0) ? fileTitle.split('.')[1].toLowerCase() : 'unknown';

    switch (strTitle) {
      //case 'txt':
      //  rtnClass = "fa fa-file-o";
      //  break;
      case 'doc':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'docx':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'xls':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'xlsx':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'pdf':
        rtnClass = "fa fa-file-pdf-o";
        break;
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'png':
        rtnClass = "fa fa-file-picture-o";
        break;
      case 'mp3':
        rtnClass = "fa fa-file-audio-o";
        break;
      case 'mp4':
      case 'mpeg':
      case 'mpg':
      case 'avi':
        rtnClass = "fa fa-file-video-o";
        break;
      default:
        rtnClass = "fa fa-file";
        break;
    }

    return rtnClass;

  }



}
